import { render, staticRenderFns } from "./IVInput.vue?vue&type=template&id=64be4181&scoped=true&"
import script from "./IVInput.vue?vue&type=script&lang=js&"
export * from "./IVInput.vue?vue&type=script&lang=js&"
import style0 from "./IVInput.vue?vue&type=style&index=0&id=64be4181&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be4181",
  null
  
)

export default component.exports